import { IDropdownItem } from '@/interfaces/storageTracking/IDropdownItem.ts';
import { IIdName } from '@/interfaces/general/IIdName.ts';
import { ISearchableContent } from '@/interfaces/storageTracking/ISearchableContent.ts';
import { useApi } from '../useApi.ts';

const apiCall = useApi('storageTracking');

async function getSearchableContent (): Promise<ISearchableContent> {
    return (await apiCall.get<ISearchableContent>({
        endpoint: '/public/ProjectsAndCompaniesSearch',
    })).data;
}

async function getTechnologies (): Promise<Array<IDropdownItem>> {
    return (await apiCall.get<Array<IDropdownItem>>({
        endpoint: '/snowflake/technologies',
    })).data;
}

async function getCountries (): Promise<Array<IDropdownItem>> {
    return (await apiCall.get<Array<IDropdownItem>>({
        endpoint: '/public/allcountries',
    })).data;
}

async function getSegments (): Promise<Array<IDropdownItem>> {
    return (await apiCall.get<Array<IDropdownItem>>({
        endpoint: '/public/segments',
    })).data;
}

async function getInstallations (): Promise<Array<IDropdownItem>> {
    return (await apiCall.get<Array<IDropdownItem>>({
        endpoint: '/public/installations',
    })).data;
}

async function getAllValueStreamsForDropdown (): Promise<Record<string, IDropdownItem[]>> {
    return (await apiCall.get<Record<string, IDropdownItem[]>>({
        endpoint: '/snowflake/AllValueStreamsForDropdown',
    })).data;
}

async function getAllCompanies (): Promise<Array<IIdName>> {
    return (await apiCall.get<Array<IIdName>>({
        endpoint: '/snowflake/GetAllCompanies',
    })).data;
}

export const FiltersApi = {
    getSearchableContent,
    getTechnologies,
    getCountries,
    getSegments,
    getInstallations,
    getAllCompanies,
    getAllValueStreamsForDropdown,
};
